<template>
  <div>
    <van-row class="top">
      <p><img class="top-img" :src="user.avatar" /></p>
    </van-row>
    <van-row>
      <van-cell-group>
        <van-field v-model="user.userId" label="学号" readonly />
        <van-field v-model="user.name" label="姓名" readonly />
        <van-field v-model="user.deptName" label="班级" readonly />
      </van-cell-group>
      <div class="btn-box">
        <van-button class="btn" @click="NoBind" type="danger">解除绑定</van-button>
      </div>
    </van-row>
  </div>
</template>
<script>
  import Vue from 'vue'
  import Vant from 'vant';
  import 'vant/lib/index.css';
  Vue.use(Vant)
  export default {
    name: "UserInfo",
    title: "身份信息",
    data () {
      return {
        user: { avatar: "", userId: "", name: "", deptName: "" },
      }
    },
    methods: {
      GetMyInfo () {
        this.Ajax.Get("api/User/GetMyInfo").then(res => {
          this.user = res.data;
        })
      },
      NoBind () {
        this.$tool.Phone.confim("确定解绑吗？").then(() => {
          this.Ajax.Post("​/api/Bind/BindStudent/" + this.info.UserID + "/" + this.info.IDCrad + "/" + this.info.Phone + "").then(res => {
            this.$tool.ss.clear();
            this.$router.push({ name: "Bind" });
          })
        }).catch(() => { });
      }
    },
    mounted () {
      this.GetMyInfo();
    },
  }
</script>
<style scoped>
  .top {
    padding: 20px 0;
    text-align: center;
  }
  .top-img {
    width: 40%;
    border-radius: 50%;
  }
  .top-text {
    padding: 15px 0;
    color: #5ba2d5;
  }
  .btn-box {
    padding: 20px 10px;
  }
  .btn {
    width: 100%;
  }
  .bottom-text {
    text-align: center;
    color: #868686;
    font-size: 14px;
  }
  .tel {
    line-height: 28px;
  }
  .tel a {
    color: #5ba2d5;
  }
</style>